import { CoolingRegimeProductGroupDetails } from "../CoolingRegimeProductGroup/CoolingRegimeProductGroupDetails";

interface Props {
  productGroupCode: string;
}

export const CoolingRegimesTabEditable: React.FC<Props> = ({ productGroupCode }) => {
  return <CoolingRegimeProductGroupDetails productGroupCode={productGroupCode} />;
};
